// Ribbon with checkmark or error
//import React, { useState } from "react";
import React from "react";

const Ribbon = (props) => {
  return (
    <div className="ribbon">
      <div
        className="ribbon_title checkmark"
        style={props.status === "checkmark" ? {} : { display: "none" }}
      ></div>
      <div
        className="ribbon_icon--checkmark"
        style={props.status === "checkmark" ? {} : { display: "none" }}
      ></div>
      <div
        className="ribbon_title error"
        style={props.status === "error" ? {} : { display: "none" }}
      ></div>
      <div
        className="ribbon_icon--error"
        style={props.status === "error" ? {} : { display: "none" }}
      ></div>
      <div
        className="ribbon_title attention"
        style={props.status === "attention" ? {} : { display: "none" }}
      ></div>
      <div
        className="ribbon_icon--attention"
        style={props.status === "attention" ? {} : { display: "none" }}
      ></div>
      <div>
        <label>{props.label}</label>
      </div>
      <div
        className={`ribbon_subheader ${
          props.status === "error" ? "ribbon_subheader--error" : ""
        }         
        `}
        style={props.subheader === "" ? { display: "none" } : {}}
      >
        {props.subheader}
      </div>
      <div
        className={`ribbon_content ${
          props.status === "error" ? "ribbon_subheader--error" : ""
        }
        `}
        style={props.content === "" ? { display: "none" } : {}}
      >
        {props.content}
		
		{/* below code use dangerouslySetInnerHTML, take string, and remove script tag, not able to handle content as object
		props.content !== undefined &&
            props.content.length > 0 &&
            <div dangerouslySetInnerHTML={{__html: (props.content && typeof props.content === 'string' && props.content.trim() !== '')
											    ? props.content.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
											    : ''
            }}/>
			}
		*/}
      </div>
    </div>
  );
};

export default Ribbon;